import React from 'react';
import { collection, onSnapshot } from 'firebase/firestore';
import { firestore } from '../../../lib';
import { Application, Category } from '../../../models';
import { SchoolIcon } from '../../icons';
import CategoryForm from './CategoryForm';

interface CategoryFormProps {
  application?: Application;
  isReadOnly?: boolean;
}

export default function SecondStep({
  application = null,
  isReadOnly = false,
}: CategoryFormProps) {
  const [categories, setCategories] = React.useState<Category[]>();
  React.useEffect(function syncData() {
    const unsubscribe = onSnapshot(
      collection(firestore, 'categories'),
      (snapshot) => {
        const _data = snapshot.docs.map((doc) => {
          const _doc = doc.data();
          return {
            ..._doc,
            createdAt:
              typeof _doc?.createdAt?.toDate === 'function'
                ? _doc.createdAt.toDate()
                : _doc.createdAt,
          };
        });
        setCategories(_data as Category[]);
      }
    );
    return () => {
      if (unsubscribe) {
        unsubscribe();
      }
    };
  }, []);
  return (
    <div className="p-6 lg:py-20 lg:px-32 flex flex-col">
      <div className="w-20 h-20 rounded-full bg-[#D8E5FF] border border-[#CBDDFF] flex">
        <SchoolIcon className="h-12 w-12 m-auto text-dark-blue" />
      </div>
      <div className="mt-8">
        <h2 className="font-bold text-5xl text-neutral-600">
          Scholarship Selection
        </h2>
        <p className="font-semibold text-lg text-neutral-500 mt-2">
          Kindly select the scholarship category you are applying for
        </p>
      </div>
      <div className="mt-8 flex flex-col">
        {categories?.length > 0 && application ? (
          <CategoryForm
            application={application}
            categories={categories}
            category={application?.category ?? 'none'}
            isReadOnly={isReadOnly}
          />
        ) : null}
      </div>
    </div>
  );
}
